import { makeStateKey, StateKey } from '@angular/core';
import { SettingsResponse } from '@app/services/settings/models/settings-response';
import { Theme } from '@app/theme/theme';
import { AgencySocialLinks } from '@back/models/agency';
import { HomePageBannerContainer } from '@app/interfaces/banners/homePageBanner';
import { TravelCompositorProducts } from '@app/interfaces/travel-compositor/travelCompositorProduct';
import { Proposal } from '@app/interfaces/proposal';
import { TravelTheme } from '@app/interfaces/travel-compositor/theme';
import { Utility } from '@app/back-office/models/utility';
import { Catalog } from '@app/interfaces/catalog';
import { BlogData } from '@app/services/blog-service/blog.service';

export const TRANSFER_STATE_KEYS = {
  HOMEPAGE_SETTINGS: makeStateKey<SettingsResponse>('homepage.settings'),

  THEME_DATA: makeStateKey<Theme>('theme.data'),

  HOSTNAME: makeStateKey<string>('hostname'),

  AGENCY_SOCIAL_LINKS: makeStateKey<AgencySocialLinks>('agency.social'),

  AGENCY_NAME: makeStateKey<string>('seo.agency_name'),

  // Homepage data keys
  HOMEPAGE_BANNERS: makeStateKey<HomePageBannerContainer>('homepage.banners'),
  HOMEPAGE_PRODUCTS: makeStateKey<TravelCompositorProducts>('homepage.products'),
  HOMEPAGE_FEATURED: makeStateKey<Proposal[]>('homepage.featured'),
  HOMEPAGE_THEMES: makeStateKey<TravelTheme[]>('homepage.themes'),
  HOMEPAGE_UTILITIES: makeStateKey<Utility[]>('homepage.utilities'),
  HOMEPAGE_CATALOGS: makeStateKey<Catalog[]>('homepage.catalogs'),
  HOMEPAGE_BLOGS: makeStateKey<BlogData[]>('homepage.blogs'),
} as const;

export type TransferStateKey = keyof typeof TRANSFER_STATE_KEYS;
